import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import {
  Step,
  Stepper,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  Typography,
} from '@mui/material';
// components
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#000',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#000',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#000',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#000',
    zIndex: 1,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Iconify icon="ic:outline-check" width={22} height={22} className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

export default function NewCoffeeChatStepper({ step }) {
  const STEPS = [
    <Typography key="1" variant={"caption"}>메시지 작성</Typography>,
    <Typography key="2" variant={"caption"}>조건 작성</Typography>,
  ];

  return (
    <>
      <Stepper sx={{ width: "240px", alignItems: "center" }} alternativeLabel activeStep={step} connector={<QontoConnector />}>
        {STEPS.map((label, index) => (
          <Step key={`l-${index}`}>
            <StepLabel
              StepIconComponent={QontoStepIcon}
              sx={{
                ".MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
                  mt: 1,
                }
              }}
            >{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </>
  );
}
